/* src/app/rt-components/footer/footer.component.scss */
:host {
  align-items: center;
  background: #ffffff;
  display: flex;
  font-size: 0.8rem;
  height: 3.1428572rem;
  justify-content: space-between;
  width: 100%;
}
@media screen and (max-width: 543px) {
  :host {
    font-size: 0.7rem;
  }
}
:host .copyright,
:host .version {
  padding: 10px 22px;
}
@media screen and (max-width: 543px) {
  :host .copyright {
    padding-right: 0;
  }
  .rtl :host .copyright {
    padding-left: 0;
    padding-right: 22px;
  }
}
/*# sourceMappingURL=footer.component.css.map */
